import axios from "axios";
import dayjs from "dayjs";

import { getInitUrl, TOKEN_TTL_MINUTES } from "./config";
import type { CachedToken, InitTokenResponse, Nullable } from "./types";

function safeParseJSON<T>(value: string | null): Nullable<T> {
  if (!value) return null;

  try {
    return JSON.parse(value) as T;
  } catch {
    return null;
  }
}

export function getCachedInitToken(storageKey: string): Nullable<CachedToken> {
  return safeParseJSON<CachedToken>(sessionStorage.getItem(storageKey));
}

export function saveCachedInitToken(storageKey: string, token: string) {
  const payload: CachedToken = {
    token,
    createdAt: dayjs().toISOString(),
  };

  sessionStorage.setItem(storageKey, JSON.stringify(payload));
}

export function clearCachedInitToken(storageKey: string) {
  sessionStorage.removeItem(storageKey);
}

export function isCachedInitTokenValid(
  cachedToken: Nullable<CachedToken>
): boolean {
  if (!cachedToken?.token || !cachedToken.createdAt) {
    return false;
  }

  const ageInMinutes = dayjs().diff(dayjs(cachedToken.createdAt), "minute");
  return ageInMinutes <= TOKEN_TTL_MINUTES;
}

export async function tokenRequest(tipo: "1" | "2") {
  return axios.get<InitTokenResponse>(getInitUrl(), {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      tipo,
    },
  });
}

export async function refreshInitToken(
  storageKey: string,
  tipo: "1" | "2"
): Promise<Nullable<string>> {
  try {
    const response = await tokenRequest(tipo);
    const accessToken = response.data.access_token;

    saveCachedInitToken(storageKey, accessToken);

    return accessToken;
  } catch (error) {
    console.error("Erro ao renovar/reobter token de inicialização:", error);
    return null;
  }
}

export async function getToken(
  storageKey: string,
  tipo: "1" | "2"
): Promise<Nullable<string>> {
  const cachedToken = getCachedInitToken(storageKey);

  if (isCachedInitTokenValid(cachedToken)) {
    return cachedToken.token;
  }

  return refreshInitToken(storageKey, tipo);
}